import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const Input = styled.input`
  width: 100%;

  border: 1px solid ${colors.grayLight};
  border-radius: 4px;

  padding: 12px 10px;

  font-weight: 400;
  font-size: 12px;

  background-color: ${colors.white};

  &:disabled {
    background: ${colors.grayExtraLight};
    color: ${colors.grayDark};
  }
`
